import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

/**
 * The AnkhOS lockup, from public/brand. Picks the reversed file in dark mode
 * so the loop and wordmark stay paper-on-ink; the hub is amber in both.
 */
export function BrandLockup({ to = "/", height = 24 }: { to?: string; height?: number }) {
  const theme = useTheme();
  const src =
    theme.palette.mode === "dark"
      ? "/brand/ankhos-lockup-horizontal-reversed.svg"
      : "/brand/ankhos-lockup-horizontal.svg";
  return (
    <Box
      component={RouterLink}
      to={to}
      aria-label="AnkhOS home"
      sx={{ display: "inline-flex", alignItems: "center", flexGrow: 1, minHeight: 44, textDecoration: "none" }}
    >
      <Box component="img" src={src} alt="AnkhOS" sx={{ height, width: "auto", display: "block" }} />
    </Box>
  );
}
